module.exports = __webpack_public_path__ + "static/media/abroad.183c6668.jpeg";